document.addEventListener("DOMContentLoaded", function () {
	if (!document.body.classList.contains("single-guide")) {
		return;
	}

	const $guideBoard = document.getElementById("stax-guide-board");
	const $guideFooter = document.getElementById("stax-guide-footer");
	const $guideMobileNav = document.getElementById("single-guide-chapter-section-nav");

	const renderGuideChapter = (content) => {
		$guideBoard.innerHTML = content;
	};

	const getCurrentURL = () => {
		return window.location.href;
	};

	const hasPipe = (string) => string.includes("|");

	const scrollToGuideTop = () => {
		document.getElementById("main-anchor").scrollIntoView({ top: 0, left: 0, behavior: "instant" });
	};

	const scrollToGuideSection = (section) => {
		const targetSectionDiv = document.getElementById(section);

		if (targetSectionDiv) {
			document.getElementById(section).scrollIntoView({
				block: "start",
				inline: "nearest",
				behavior: "instant",
			});

			history.pushState(null, null, "#" + section);
		}
	};

	const updateGuideSidebar = (chapter) => {
		const allChapters = document.querySelectorAll(".single-guide-chapter-list li");

		allChapters.forEach((item) => {
			item.classList.remove("active");
		});

		const targetChapter = document.querySelector(`.chapter-${chapter}`);
		targetChapter.classList.add("active");
	};

	const updateGuideFooter = (data) => {
		if (0 === parseInt(data.has_next) && 0 === parseInt(data.has_prev)) {
			$guideFooter.classList.add("hidden");
			return;
		}

		$guideFooter.classList.remove("hidden");

		const btnNext = $guideFooter.querySelector(".single-guide-chapter-next");
		const btnPrev = $guideFooter.querySelector(".single-guide-chapter-prev");

		if (1 === parseInt(data.has_next)) {
			btnNext.classList.remove("hidden");
			btnNext.dataset.chapter = data.next.chapter_slug;
			const nextText = btnNext.querySelector(".single-guide-chapter-next-text");
			nextText.innerHTML = data.next.chapter_title;
		} else {
			btnNext.classList.add("hidden");
		}

		if (1 === parseInt(data.has_prev)) {
			btnPrev.classList.remove("hidden");
			btnPrev.dataset.chapter = data.prev.chapter_slug;
		} else {
			btnPrev.classList.add("hidden");
		}
	};

	const updateGuideURL = (chapter) => {
		let hashPart = "";

		if (1 !== parseInt($guideBoard.dataset.bootstrapped)) {
			const myUrl = new URL(getCurrentURL());
			hashPart = myUrl.hash;
		}

		const nextURL = $guideBoard.dataset.baseurl + chapter + "/" + hashPart;
		window.history.pushState(null, null, nextURL);
		window.history.replaceState(null, null, nextURL);
	};

	const handleGuideChapter = (args = {}) => {
		let { chapter, section, mobileMode } = args;

		if (!chapter) {
			chapter = $guideBoard.dataset.cid;
		}

		const formData = new FormData();

		formData.append("action", "stax_get_guide_chapter");
		formData.append("id", $guideBoard.dataset.gid);
		formData.append("chapter", chapter);

		const guideSpinner = document.querySelector(".guide-spinner");
		$guideBoard.innerHTML = guideSpinner.innerHTML;
		$guideFooter.classList.add("hidden");

		if (section) {
			scrollToGuideSection(section);
		} else {
			scrollToGuideTop();
		}

		fetch(LOCALIZED.ajax_url, {
			method: "POST",
			credentials: "same-origin",
			body: formData,
		})
			.then((response) => response.json())
			.then((result) => {
				if (result.data) {
					renderGuideChapter(result.data.content);
					updateGuideSidebar(chapter);
					updateGuideURL(chapter);
					updateGuideFooter(result.data);

					if (mobileMode) {
						scrollToGuideSection(section);
					}

					$guideBoard.dataset.bootstrapped = "1";
				}
			})
			.catch((error) => {
				renderGuideChapter("Error occurred.");
				$guideBoard.dataset.bootstrapped = "1";
			});
	};

	handleGuideChapter();

	const allTriggers = document.querySelectorAll(".js-btn-stax-guide-chapter");

	allTriggers.forEach((btn) => {
		btn.addEventListener("click", function (e) {
			e.preventDefault();

			const chapterValue = e.currentTarget.dataset.chapter;

			handleGuideChapter({
				chapter: chapterValue,
			});
		});
	});

	// Mobile nav.
	$guideMobileNav.addEventListener("change", function (e) {
		const optValue = e.target.value;

		const isSection = hasPipe(optValue);

		if (!isSection) {
			handleGuideChapter({
				chapter: optValue,
			});
		} else {
			const exploded = optValue.split("|");

			handleGuideChapter({
				chapter: exploded[0],
				section: exploded[1],
				mobileMode: true,
			});
		}
	});
});
